import {  useEffect, useState } from "react";
import { Menu } from "../../components/menu/menu";
import { bemCN } from "../../config/bem-classname";
import { ReactComponent as MessageIcon } from "../../shared/images/svg/message.svg";
import { ReactComponent as LockIcon } from "../../shared/images/svg/lock.svg";
import { ReactComponent as PenIcon } from "../../shared/images/svg/pen.svg";
import { Input, TypeDataInput, TypeViewInput } from "../../ui/input/input";
import "./profile-info-page.scss";
import { UpdatePasswordRequestDTO, UserDTO } from "../../api/Api";
import { userService } from "../../services/user-service";
import { Button, ButtonColors, ButtonSizes } from "../../ui/button/button";
import { useNavigate } from "react-router-dom";
import { links } from "../../config/links";
import { authService } from "../../services/auth-service";
import { passwordHasError } from "../../utils/validation-input";

const profileInfoPageCn = bemCN("profile-info-page");

export const ProfileInfoPage = () => {
  const [user, setUser] = useState<UserDTO>({ email: "", name: "", planId: 0 });
  const [isShowEditPassword, setIsShowEditPassword] = useState(false);

  const [password, setPassword] = useState<UpdatePasswordRequestDTO>({
    email: "",
    code: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [isDisableButton, setIsDisableButtno] = useState(false);
  const [errorText, setErrorText] = useState<string>();
  const navigate = useNavigate();

  useEffect(() => {
    userService.getUser().then((res: UserDTO) => {
      setUser(res);
      setPassword({ ...password, email: res.email || "" });
    });
  }, [1]);

  useEffect(() => {
    if (
      !passwordHasError(password.newPassword) &&
      !passwordHasError(password.confirmPassword) &&
      password.newPassword == password.confirmPassword
    ) {
      setIsDisableButtno(true);
    } else {
      setIsDisableButtno(false);
    }
  }, [password]);

  const onClickRecoveryPassword = () => {
    setErrorText(undefined);

    authService.recoveryPassword(password).then((res: any) => {
      if (res == 200) {
        navigate(links.profile);
      } else {
        setErrorText(res);
      }
    });
  };

  const onClickEditPassword = () => {
    authService
      .sendCodeRecoveryPassword({ email: user.email || "" })
      .then((res: any) => {
        if (res == 200) {
          setIsShowEditPassword(true);
        } else {
          setErrorText(res);
        }
      });
  };
  return (
    <div className={profileInfoPageCn()}>
      <Menu title="Ваши данные" />
      <div className={profileInfoPageCn("view-info")}>
        <Input
          isDisable={true}
          icon={<MessageIcon />}
          placeholder="Email"
          value={user?.email}
          typeView={TypeViewInput.text}
          typeData={TypeDataInput.text}
        />
        <div className={profileInfoPageCn("password-view")}>
          <LockIcon />
          <p>***********</p>
          <Button
            icon={<PenIcon />}
            size={ButtonSizes.small}
            color={ButtonColors.transition}
            onClick={onClickEditPassword}
          />
        </div>
      </div>
      {isShowEditPassword && (
        <>
          <h1>Установите новый пароль</h1>
          <div className={profileInfoPageCn("view-info")}>
            <Input
              onChange={(v: string) => setPassword({ ...password, code: v })}
              icon={<MessageIcon />}
              placeholder="Код из письма"
              value={password.code}
              typeView={TypeViewInput.text}
              typeData={TypeDataInput.text}
            />
            <Input
              icon={<LockIcon />}
              placeholder="Новый пароль"
              value={password.newPassword}
              typeView={TypeViewInput.password}
              typeData={TypeDataInput.password}
              onChange={(v: string) =>
                setPassword({ ...password, newPassword: v })
              }
              isValidate
            />
            <Input
              icon={<LockIcon />}
              placeholder="Повторите пароль"
              value={password.confirmPassword}
              typeView={TypeViewInput.password}
              typeData={TypeDataInput.password}
              onChange={(v: string) =>
                setPassword({ ...password, confirmPassword: v })
              }
              isValidate
            />
            <Button
              onClick={onClickRecoveryPassword}
              text="Подтвердить"
              color={ButtonColors.green}
              size={ButtonSizes.big}
              noDisabled={!isDisableButton}
            />
          </div>
          {errorText && <p>{errorText}</p>}
        </>
      )}
    </div>
  );
};
